const VALUE_KIND_BY_TYPE = {
    HEADING: 'none',
    PARAGRAPH: 'none',
    DIVIDER: 'none',
    INFO: 'none',
    SHORT_TEXT: 'text',
    LONG_TEXT: 'text',
    EMAIL: 'text',
    NUMBER: 'number',
    DATE: 'date',
    SELECT: 'text',
    RADIO: 'text',
    CHECKBOX: 'boolean',
    MULTI_CHECKBOX: 'list',
    FULL_NAME: 'text',
    INITIALS: 'text',
    ACKNOWLEDGEMENT: 'boolean',
    AGREEMENT: 'boolean',
    SIGNATURE: 'signature',
};
export function fieldValueKind(type) {
    return VALUE_KIND_BY_TYPE[type];
}
/** Content blocks render text but never collect an answer. */
export function isContentField(type) {
    return VALUE_KIND_BY_TYPE[type] === 'none';
}
/** Fields whose acceptance must be explicitly recorded in the audit trail. */
export function isLegalField(type) {
    return type === 'ACKNOWLEDGEMENT' || type === 'AGREEMENT';
}
/** Field types that offer a list of options. */
export function hasOptions(type) {
    return type === 'SELECT' || type === 'RADIO' || type === 'MULTI_CHECKBOX';
}
/**
 * Field types that can be placed on top of a PDF page. Long text, selects and
 * radios are deliberately excluded: they have no sensible flattened rendering
 * inside a fixed box on a pre-existing document.
 */
export const PDF_PLACEABLE_FIELD_TYPES = [
    'SHORT_TEXT',
    'EMAIL',
    'NUMBER',
    'DATE',
    'FULL_NAME',
    'INITIALS',
    'CHECKBOX',
    'SIGNATURE',
];
export function isPdfPlaceable(type) {
    return PDF_PLACEABLE_FIELD_TYPES.includes(type);
}
//# sourceMappingURL=fields.js.map